import SectionMessage, {
  SectionMessageAction,
} from '@atlaskit/section-message';
import React, { ReactElement, ReactNode } from 'react';
const refreshPage = () => window.location.reload();

interface ErrorMessageProps {
  title: string;
  text: ReactNode;
  actions?: ReactElement[];
}

export function ErrorMessage({
  title,
  text,
  actions,
}: Readonly<ErrorMessageProps>) {
  return (
    <SectionMessage
      data-testid="error-message"
      title={title}
      appearance="error"
      actions={
        actions?.length
          ? actions
          : [
              <SectionMessageAction key="1" onClick={refreshPage}>
                Reload app
              </SectionMessageAction>,
            ]
      }
    >
      <p>{text}</p>
    </SectionMessage>
  );
}
